<template>
  <div id="apppp">
    <div id="demo"></div>
  </div>
</template>
<script>
import Pdfh5 from "pdfh5";
export default {
  data () {
    return {
      /* pdf 地址 */
      pdfh5: null
    }
  },

  mounted() {
    let parseItem = JSON.parse(this.$route.query.item)
    let url = parseItem.dataUrl 

    //实例化
    this.pdfh5 = new Pdfh5("#demo", { 
      pdfurl: url,
      // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist/cmaps/'
    })
 
    //监听完成事件
    this.pdfh5.on("complete", function (status, msg, time) {
      // console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
    })
  },
}
</script>

<style>
  @import "pdfh5/css/pdfh5.css";
</style>

<style lang="scss" scoped>

  #apppp {
    width: 100%;
    height: 100%;
  }

  #apppp *{
    padding: 0;
    margin: 0;
  }
</style>
